import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import achievementAPI from "../api/achievementApi";

const CulturalTalentDetail = () => {
  const { id } = useParams();

  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchEvent = async () => {
      setLoading(true);
      setError(false);
      setEvent(null);

      try {
        const response = await achievementAPI.achievements_listing();

        if (!isMounted) return;

        const events =
          response?.code === 200 &&
          Array.isArray(response?.data?.["creative-achievement"])
            ? response.data["creative-achievement"]
            : [];

        const selectedEvent = events.find(
          (item) => String(item.id) === String(id)
        );

        if (selectedEvent) {
          setEvent(selectedEvent);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching cultural achievement:", err);

        if (isMounted) {
          setError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchEvent();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const description =  event?.description || "";
  
  const longDesc = event?.longDesc || "";

  return (
    <div className="mrv-cultural-detail-root">
      <BreadCrumbBanner
        title={event?.title || "Cultural Achievement"}
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      <section className="mrv-cultural-detail-section">
        <div className="container">

          {/* Back Navigation */}
          <div className="mrv-cultural-back">
            <Link to="/achievements">
              <i className="fa-solid fa-arrow-left"></i>
              Back to Achievements
            </Link>
          </div>

          {/* Loading */}
          {loading ? (
            <div className="mrv-cultural-state">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading cultural achievement...</p>
            </div>
          ) : error || !event ? (

            /* Not Found */
            <div className="mrv-cultural-state">
              <i className="fa-solid fa-award"></i>
              <h3>Achievement Not Found</h3>
              <p>
                The cultural achievement details could not be found.
              </p>

              <Link
                to="/achievements"
                className="mrv-cultural-back-btn"
              >
                View All Achievements
              </Link>
            </div>
          ) : (

            /* Cultural Achievement Detail */
            <motion.article
              className="mrv-cultural-detail-card"
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <header className="mrv-cultural-detail-header">
                <span className="mrv-cultural-eyebrow">
                  CULTURAL TALENT
                </span>

                <h1>{event.title}</h1>

                <span className="mrv-cultural-divider"></span>

                {event.name && (
                  <p className="mrv-cultural-category">
                    <i className="fa-solid fa-award"></i>
                    {event.name}
                  </p>
                )}
              </header>

              {/* Featured Image */}
              {event.logo && (
                <div className="mrv-cultural-image-wrap">
                  <img
                    src={event.logo}
                    alt={event.title || event.name || "Cultural achievement"}
                    className="mrv-cultural-image"
                  />
                </div>
              )}

              {/* Full Description */}
              {description && (
                <div className="mrv-cultural-content">
                  <div
                    className="mrv-cultural-description"
                    dangerouslySetInnerHTML={{
                      __html: description,
                    }}
                  />
                </div>
              )}
              {longDesc && (
                <div className="mrv-cultural-content1">
                  <div
                    className="mrv-cultural-description1"
                    dangerouslySetInnerHTML={{
                      __html: longDesc,
                    }}
                  />
                </div>
              )}

              <footer className="mrv-cultural-footer">
                <Link
                  to="/achievements"
                  className="mrv-cultural-back-btn"
                >
                  
                  Explore More Achievements &rarr;
                </Link>
              </footer>
            </motion.article>
          )}
        </div>
      </section>
    </div>
  );
};

export default CulturalTalentDetail;